module.exports = __webpack_public_path__ + "static/mr-concert-performance-29-d29414603eeff776478fa2f4c3f87caa.jpg";